import { SR_API_ACTION_GET_USER_BOOKMARKS } from 'api/actionTypes';

export default async function getBookmarks({ state, apiClient }) {
  if (state.get(['bookmarksByListingId'])) {
    return;
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_USER_BOOKMARKS,
    state: state,
    onSuccess(bookmarks) {
      const bookmarksByListingId = bookmarks.reduce(
        (acc, listingId) => ({
          ...acc,
          [listingId]: true,
        }),
        {},
      );

      state.set(['bookmarksByListingId'], bookmarksByListingId);
    },
  });
}
